import React from 'react';
import { useEventsFeature } from '@/contexts/EventsFeatureContext';
import './Footer.css';

const Footer: React.FC = () => {
  const { forecastEnabled } = useEventsFeature();

  return (
    <footer className="footer">
      <div className="footer-content">
        <a href="/privacy" className="footer-link">Privacy Policy</a>
        <div className="footer-separator"></div>
        <a href="/terms" className="footer-link">Terms of Service</a>
        <div className="footer-separator"></div>
        <a href="/support" className="footer-link">Help Center</a>
        {forecastEnabled ? (
          <>
            <div className="footer-separator"></div>
            <a href="/forecast/upland" className="footer-link">Upland forecast</a>
          </>
        ) : null}
        <div className="footer-separator"></div>
        <a href="/changelog" className="footer-link">Changelog</a>
        <div className="footer-separator"></div>
        <a href="/maps" className="footer-link">Maps</a>
      </div>
    </footer>
  );
};

export default Footer;
